angular.module('graph').controller('ph-drop-conversations', [
    '$scope', '$http', '$rootScope', 'ph-touch-service',
    function(
        $scope, $http, $root, $phtouch
    ) {
        $scope.conversations = [];

        var $paging = 0;
        var $pg_let = 0;
        var $module = 'ph-drop-conversations';

        $phtouch.$watch($scope, $module, function() {
            $phtouch.$touch($module, function() {
                $scope.find();
            });
        });

        $scope.find = function() {
            $http.get('/xhr/me/conversations?page=' + +(++$paging) + '&let=' + $pg_let)
                .then(function($response) {
                    $scope.conversations = $scope.conversations.concat(
                        $response.data.data
                    );

                    $scope.dconversations = $scope.conversations;
                });
        };
    }
]);

angular.module('graph').controller('ph-conversations', [
    '$scope', '$rootScope', 'ph-core', 'ph-broadcast',
    function(
        $scope, $root, $core, $broadcast
    ) {
        $scope.conversation  = null;
        $scope.conversations = [];
        $scope.$items        = 25;
        $scope.$page         = 0;
        $scope.$let          = 0;
        $scope.$inited       = 0;

        $scope.find = function() {
            $core.get('/xhr/me/conversations?page=' + +(++$scope.$page) + '&let=' + $scope.$let)
                .then(function($response) {
                    var connect = [];

                    /**
                     *
                     */
                    for (var i = 0; i < $response.data.data.length; i++) {
                        connect.push($response.data.data[i].id);
                    }

                    /**
                     *
                     */
                    $broadcast.emit('join:conversation', connect);

                    /**
                     *
                     */
                    $scope.conversations = $scope.conversations.concat(
                        $response.data.data
                    );

                    if ($scope.$inited === 0) {
                        ++$scope.$inited;
                        $scope.touch($scope.conversations[0]);
                    }
                });
        };

        $scope.touch = function($conversation) {
            $scope.conversation = $conversation;

            $scope.$broadcast('ph-conversation-touch', $scope.conversation);
        };

        /**
         *
         */
        $broadcast.on('conversation:message:publish', function($data, $guid) {
            $core.$array.find($scope.conversations, $data['entry'].id, function(conversation, key) {
                console.log(conversation);
                $scope.conversations[key].recent = $data['meta'];
                $root.$digest();
            }, function() {
                // console.log('not found');
            });
        });

        $scope.find();
    }
]);

angular.module('graph').controller('ph-conversation-messages', [
    '$scope', '$rootScope', 'ph-core', 'ph-broadcast',
    function(
        $scope, $root, $core, $broadcast
    ) {
        $scope.$conversation  = null;
        $scope.messages      = [];
        // $scope.$items        = 25;
        $scope.$page         = 0;
        $scope.$let          = 0;
        $scope.isLoad        = 0;

        $scope.$event        = {
            "publish" : function($message) {
                ++$scope.$let;
                $scope.messages.push($message);
            }
        };

        $scope.$on('ph-conversation-touch', function (event, $conversation) {
            $scope.$conversation = $conversation;
            $scope.messages      = [];
            $scope.$page         = 0;
            $scope.$let          = 0;

            $scope.find();
        });

        $scope.find = function() {
            $core.get('/xhr/conversation/' + $scope.$conversation.id + '?page=' + +(++$scope.$page) + '&let=' + $scope.$let)
                .then(function($response) {
                    $scope.messages = $response.data.data.concat(
                        $scope.messages
                    );
                    $scope.isLoad = 1;
                });
        };

        $scope.publish = function() {
            $core.post('/xhr/conversation/' + $scope.$conversation.id, {
                "message" : $scope.message
            }).then(function($response) {
               if ($response.data.state === 0) {
                   $scope.$event.publish($response.data.data);

                   $scope.message = '';
               } else if ($response.data.state === 7) {
                   $root.$broadcast('ph-modal-show', $response.data.data.message);
               }
            });
        };

        $scope.keyboard = function($event) {
            if ( $event.which === 13 ) {
               if( $event.shiftKey ) {
                   // make enter
               } else {
                   $event.preventDefault();
                   $scope.publish();
               }
           }
       };

       /**
        *
        */
       $broadcast.on('conversation:message:publish', function($data, $guid) {
           if ($core.$guid !== $guid && $scope.$conversation.id === $data.entry.id)
                $scope.$event.publish($data.meta);
       });
    }
]);
